<template>
  <div v-if="contentType === 'structured_list'" class="card mt-4">
    <hr>
    <h5 class="card-title mt-4">Modelo pronto</h5>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-md-8">
          <label class="form-label">Preset de prescrição</label>
          <select class="form-select" v-model="selectedListPreset">
            <option value="">--Selecione um modelo--</option>
            <option v-for="(preset, key) in structuredListPresets" :key="key" :value="key">{{ preset.label }}</option>
          </select>
          <small v-if="selectedListPresetDescription" class="text-muted d-block mt-2">{{ selectedListPresetDescription }}</small>
        </div>
        <div class="col-md-4 d-flex align-items-end">
          <button type="button" class="btn btn-light-primary w-100" @click="applyListPreset" :disabled="!selectedListPreset">
            Aplicar modelo
          </button>
        </div>
      </div>
    </div>
  </div>

  <AttributeOptionsEditor
      v-if="mappedType"
      :model-value="modelValue"
      :type="mappedType"
      :grid-presets="gridPresets"
      @update:modelValue="$emit('update:modelValue', $event)"
  />
</template>

<script>
import AttributeOptionsEditor from "../../record_type/components/AttributeOptionsEditor.vue";

export default {
  name: "PrescriptionModelOptionsEditor",
  components: {AttributeOptionsEditor},
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: [Array, Object, String, null],
      default: null,
    },
    contentType: {
      type: String,
      default: 'medication',
    },
    gridPresets: {
      type: Object,
      default: () => ({}),
    },
    structuredListPresets: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedListPreset: '',
    };
  },
  computed: {
    mappedType() {
      if (this.contentType === 'grid') {
        return 'grid';
      }
      if (this.contentType === 'structured_list') {
        return 'structured_list';
      }
      return '';
    },
    selectedListPresetDescription() {
      if (!this.selectedListPreset || !this.structuredListPresets[this.selectedListPreset]) {
        return '';
      }
      return this.structuredListPresets[this.selectedListPreset].description ?? '';
    },
  },
  methods: {
    applyListPreset() {
      const preset = this.structuredListPresets[this.selectedListPreset];
      if (!preset?.options) {
        return;
      }
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(preset.options)));
    },
  },
};
</script>
